<div class="successfull" *ngIf="showSuccessDiv">
    <img src="https://images.5paisa.com/forum/success-icon.svg"/>
    <h3>Ticket Created Successfully!</h3>
    <span>Your ticket no. is {{ticketNumber}}.</span>
    <button type="submit" class="sucessfull-btn" (click)="closeSuccess()">Done</button>
</div>

<div class="pending" *ngIf="showPendingDiv">
    <img src="https://images.5paisa.com/forum/pending-icon.svg"/>
    <h3>Ticket Creation is Pending.</h3>
    <!-- <span>Your ticket no. is 109583679800.</span> -->
    <button type="submit" class="sucessfull-btn" (click)="close()">Alright</button>
</div>

<div class="failed" *ngIf="showFailedDiv">
    <img src="https://images.5paisa.com/forum/failed-icon.svg"/>
    <h3>Ticket Creation Failed.</h3>
    <span>Something went wrong. please try again.</span>
    <button type="submit" class="sucessfull-btn" (click)="close()">Try Again</button>
</div>

<div class="detail-pending" *ngIf="showInvalidDiv">
    <div class="pending-label">
        <span class="alert">!</span>
        <span class="text">Please fill all mandatory fields
        </span>
    </div>
    <button type="submit" class="sucessfull-btn" (click)="close()">Okay</button>
</div>

<div class="detail-pending" *ngIf="showNotLoginDiv">
    <div class="pending-label">
        <span class="alert">!</span>
        <span class="text">Want to Chat or Create Ticket, Please Login first.</span>
    </div>
    <div class="button-wrapper">
        <button type="submit" class="sucessfull-btn" (click)="close()">Close</button>
        <button type="submit" class="login-btn" (click)="Login()">Login</button>
    </div>
    
</div>